import RequestUtils from "utils/RequestUtils";

export type DashboardSummary = {
  today: {
    bookingCount: number;
    bookingSales: number;
    paidCount: number;
    paidSales: number;
    shiftCount: number;
  };
  weekShifts: { date: string; count: number }[];
  weekBookings: { date: string; count: number }[];
  actionable: {
    castRequest: number;
    guestRequest: number;
  };
  todayShifts: {
    castShiftId: number;
    castId: number;
    displayName: string;
    planWorkStart: string;
    planWorkEnd: string;
    actualWorkStart: string | null;
    status: string;
  }[];
};

export default class DashboardApi {
  private constructor() {}

  /**
   * ダッシュボード用サマリー一式を 1 コールで取得。
   * 画面ロード時の 8+ API コールをまとめて体感ラグを解消する。
   */
  static async summary(
    companyId: number,
    date: string // yyyy-MM-dd
  ): Promise<DashboardSummary> {
    return (await RequestUtils.getPlain(
      `/dashboard/summary/${companyId}/${date}`
    )) as DashboardSummary;
  }
}
